export type PageContainerProps = React.HTMLAttributes<HTMLDivElement> & {
	children: React.ReactNode
}

export type DefaultPageContainerProps = {
	children: React.ReactNode
};

export const defaultProps: DefaultPageContainerProps = {
	children: null,
};
